import type { CreateUserResponse } from "@pokifolio/contracts";
import { useState } from "react";

import { ErrorAlert } from "../../components/ui/alert";
import { Card } from "../../components/ui/card";
import { useCurrentUser } from "../auth/session";
import { CreateUserCard } from "./create-user-card";
import { TemporaryPasswordNotice } from "./temporary-password-notice";
import { UserRow } from "./user-row";
import { useUsers } from "./users-queries";

export function UsersPage() {
  const users = useUsers();
  const { user: me } = useCurrentUser();
  const [created, setCreated] = useState<CreateUserResponse | null>(null);

  return (
    <div className="flex flex-col gap-6">
      <div>
        <h1 className="text-2xl font-semibold text-foreground">Users</h1>
        <p className="mt-1 text-sm text-muted-foreground">
          Create accounts, change roles and control who can do what.
        </p>
      </div>

      {created !== null && <TemporaryPasswordNotice created={created} onDone={() => setCreated(null)} />}
      <CreateUserCard onCreated={setCreated} />

      <Card className="overflow-x-auto p-0">
        {users.isPending ? (
          <p className="p-6 text-sm text-muted-foreground">Loading users…</p>
        ) : users.isError ? (
          <div className="p-6">
            <ErrorAlert error={users.error} />
          </div>
        ) : (
          <table className="w-full min-w-[720px] text-left">
            <caption className="sr-only">All user accounts</caption>
            <thead className="text-xs uppercase tracking-wide text-muted-foreground">
              <tr>
                <th scope="col" className="px-4 py-3 font-medium">
                  Person
                </th>
                <th scope="col" className="px-4 py-3 font-medium">
                  Role
                </th>
                <th scope="col" className="px-4 py-3 font-medium">
                  Status
                </th>
                <th scope="col" className="px-4 py-3 font-medium">
                  Permissions
                </th>
                <th scope="col" className="px-4 py-3 text-right font-medium">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody>
              {users.data.map((user) => (
                <UserRow key={user.id} user={user} isSelf={user.id === me.id} />
              ))}
            </tbody>
          </table>
        )}
      </Card>
    </div>
  );
}
